/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useRef } from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import { parseProps } from '../@base/@uteis';

import FieldFeedback from '../@base/FieldFeedback';
import styles from './TagsInput.module.css';

const removeButton = (props) => (
  <button onClick={props.onRemove} {...props} type="button">
    <i className="fa fa-times fa-sm" aria-hidden="true" />
  </button>
);

const TagInput = (_props) => {
  const component = useRef();
  const props = parseProps(_props);
  const [tags, setTags] = useState(props.value ? props.value : []);

  const equalArrays = (arrayA, arrayB) => {
    if (arrayA.length === arrayB.length
      && arrayA.every((v, i) => v.text === arrayB[i].text)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (component.current) {
      const tagWrapper = component.current.querySelector('.react-tags-wrapper');
      const tagInput = component.current.querySelector('input.ReactTags__tagInputField');
      tagWrapper.addEventListener('click', () => {
        tagInput.focus();
      });
    }
  }, [component]);

  useEffect(() => {
    if (props.onChange && props.value) {
      if (!equalArrays(props.value, tags)) {
        props.onChange([...tags]);
      }
    }
  }, [tags]);

  useEffect(() => {
    if (props.value) {
      if (!equalArrays(props.value, tags)) {
        setTags(props.value);
      }
    }
  }, [props.value]);

  const handleAddition = (tag) => {
    if (tag.text.length > 0) {
      setTags([...tags, tag]);
    }
  };

  const handleDelete = (i) => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const delimiters = props.delimiters ? props.delimiters : [9, 13, 188];

  const attr = {
    valid: props.valid,
    invalid: props.invalid,
  };

  let classes = styles.TagsInput;
  if (props.classes) classes = `${classes} ${props.classes}`;
  if (props.inline) classes = `${classes} inline`;

  const label = props.label ? (
    <div style={{ minWidth: props.labelWidth }}>
      <label>{props.label}</label>
    </div>
  ) : null;

  let feedback = null;
  if ('feedback_message' in props) {
    feedback = <FieldFeedback {...props} />;
  }
  if ('feedback' in props) {
    feedback = props.feedback;
  }

  return (
    <div className={classes} {...attr} ref={component}>
      {label}
      <ReactTags
        removeComponent={removeButton}
        classNames={{ tags: styles.Tags }}
        delimiters={delimiters}
        tags={tags}
        handleAddition={handleAddition}
        handleDelete={handleDelete}
        placeholder={props.placeholder}
        handleInputBlur={(e) => handleAddition({ id: e, text: e })}
        handleDrag={handleDrag}
      />
      {feedback}
    </div>
  );
};

export default TagInput;
